import {
  FormGridItem,
  type FormGridItemProps,
  MenuItem,
  Select,
  type SelectProps,
  useSelectValidator,
} from '@ace-clublabs/shared-component-library';

import { getRequiredFieldSx } from '../utils';

type CommunicationPreference = 'Phone' | 'Email' | undefined;

export interface CommunicationPreferenceFieldProps {
  value?: CommunicationPreference;
  onChange: (value: CommunicationPreference) => void;
  required?: boolean;
  fieldProps?: Partial<SelectProps>;
  validatorProps?: Parameters<typeof useSelectValidator>[0];
  gridItemProps?: Partial<FormGridItemProps>;
}

export const CommunicationPreferenceField: React.FC<
  CommunicationPreferenceFieldProps
> = ({
  value,
  onChange,
  required = false,
  fieldProps,
  validatorProps,
  gridItemProps,
}) => {
  const label = 'How should we contact you?';
  const validator = useSelectValidator({
    label,
    required,
    ...validatorProps,
  });

  return (
    <FormGridItem
      size={{ xs: 12, lg: 6 }}
      data-testid='communicationPreferenceContainer'
      {...gridItemProps}
      sx={getRequiredFieldSx(required)}
    >
      <Select
        label={label}
        placeholder='Select one'
        onChange={(e) => onChange(e.target.value as CommunicationPreference)}
        defaultValue={value}
        validator={validator}
        name='communicationPreference'
        fullWidth={true}
        data-testid='communicationPreference'
        {...fieldProps}
      >
        {['Phone', 'Email'].map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormGridItem>
  );
};
